<template>
  <div class="form-container">
    <div class="title-wrap">
      <a-row>
        <a-col :span="16" :offset="5">
          <span class="title">账号注册</span>
        </a-col>
      </a-row>
    </div>
    <CustomForm
      :formRootInstance="formRootInstance"
      :formRules="formRules"
      :initModel="initModel"
      :tempModel="tempModel"
      :submitButtonOptions="submitButtonOptions"
      :curCaptchaPath="curCaptchaPath"
      type="isRegisterForm"
      @refreshAuthCode="getCaptchaPath"
      @submit="handleSubmitForm"
    >
      <template v-slot:footer>
        <a-row>
          <a-col :span="8" :offset="3">
            <a class="a-tag-init" @click="cbOperation('login')">登录已有账号</a>
          </a-col>
          <a-col :span="6" :offset="6">
<!--            <a class="a-tag-init" @click="backHome">返回首页</a>-->
          </a-col>
        </a-row>
      </template>
    </CustomForm>
    <!-- <Loading :loading="loading" /> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import CustomForm from '@/components/CustomForm/index'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import mixinLogin from '../mixins/index'
import { captchaImage, Register } from '@/api/user'
// import { setStorage } from '@/utils/index'
export default {
  mixins: [mixinConfigSetting, mixinLogin],
  components: {
    CustomForm
  },
  props: {
    formConfig: Object
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('user', ['role', 'account', 'visitor', 'token'])
  },
  mounted() {
    // 验证码
    this.getCaptchaImage()
  },
  methods: {
    ...mapMutations('user', ['SET_ACCOUNT', 'SET_ROLE', 'SET_TOKEN']),
    getCaptchaImage() {
      captchaImage().then(res => {
        if (res.code === 200) {
          this.curCaptchaPath = `data:image/gif;base64,${res.img}`
          this.uuid = res.uuid
        }
      })
    },
    getCaptchaPath() {
      this.getCaptchaImage()
    },
    async handleSubmitForm(formValue) {
      this.callWithHandlerError(() => {
        const { form } = formValue
        form.uuid = this.uuid
        this.normalizeLoginForm(form)
        if (form.password !== form.affirmPassword) {
          this.$message.error('两次密码不相同')
          return
        }
        Register(form).then(res => {
          if (res.code === 200) {
            this.$message.success('注册成功!')
            this.cbOperation('login')
          } else {
            this.getCaptchaPath() // 重新获取验证码
            this.$message.warning(res.msg)
          }
        })
      })
    },
    normalizeLoginForm() {
      // 标准化参数
      // console.log(form, '注册表单')
    }
  }
}
</script>

<style scoped>
.form-container {
  background: rgba(255, 255, 255, 0.85)!important;
  width: 480px;
  height: auto;
  border-radius: 4px;
  position: absolute;
  right: 10%;
}

.title-wrap {
  text-align: center;
}
</style>
